"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckTablesAvailabilityMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class CheckTablesAvailabilityMapper {
    toDomain(result) {
        var _a;
        const idPos = lodash_1.default.get(result, "data.checkTablesAvailability.idPos");
        const label = lodash_1.default.get(result, "data.checkTablesAvailability.label");
        const tables = (_a = lodash_1.default.get(result, "data.checkTablesAvailability.tables")) === null || _a === void 0 ? void 0 : _a.map((t) => ({
            status: t.status,
            tableNumber: t.tableNumber,
        }));
        return {
            idPos,
            label,
            tables,
        };
    }
}
exports.CheckTablesAvailabilityMapper = CheckTablesAvailabilityMapper;
